import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { validaSoloNumero, validaEmail } from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Dimmer } from "../spinner";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoAgente from "../../catalogos/catalogoAgente";
import { Mensaje, MensajeSiNo } from "../mensajes";

const ModalActUsuarioTimbres = (props) => {
  const chkExonerar = useRef();
  const chkExonInteres = useRef();
  const chkExonMulta = useRef();
  const chkExonRecargo = useRef();

  const chkExonerarEnte = useRef();
  const chkExonInteresEnte = useRef();
  const chkExonMultaEnte = useRef();
  const chkExonRecargoEnte = useRef();

  const chkFvCon = useRef();
  const chkFvInc = useRef();
  const chkFvMod = useRef();
  const chkFvEli = useRef();
  const chkFvTodo = useRef();
  const chkExCon = useRef();
  const chkExInc = useRef();
  const chkExMod = useRef();
  const chkExEli = useRef();
  const chkEntCon = useRef();
  const chkEntInc = useRef();
  const chkEntMod = useRef();
  const chkEntEli = useRef();
  const chkExTodo = useRef();
  const chkEntTodo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnEnviar = useRef();
  const [itemAcctimbresfis, setitemAcctimbresfis] = useState();
  const [itemAccopexpendios, setItemAccopexpendios] = useState();
  const [itemAccopentes, setItemAccopentes] = useState();
  const [itemAccconfigtimbres, setItemAccconfigtimbres] = useState();
  const [itemAccpdftimbres, setItemAccpdftimbres] = useState();
  const [itemAccfvmtimbres, setItemAccfvmtimbres] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [correo, setCorreo] = useState("");
  const [visibleCheck, setVisibleCheck] = useState({
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
  });
  const [reportes, setReportes] = useState({
    pdf1: "",
    pdf2: "",
    pdf3: "",
    pdf4: "",
    pdf5: "",
    pdf6: "",
    pdf7: "",
    pdf8: "",
    pdf9: "",
  });
  const [modulos, setModulos] = useState({
    modulo1: "",
    modulo2: "",
    modulo3: "",
    modulo4: "",
    modulo5: "",
    modulo6: "",
    modulo7: "",
    modulo8: "",
  });

  const [opExonerar, setOpExonerar] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
  });

  const [opExonerarEnte, setOpExonerarEnte] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
  });

  const [modulosConfig, setModulosConfig] = useState({
    moduloconfig1: "",
    moduloconfig2: "",
    moduloconfig3: "",
  });

  const [opExpendio, setOpExpendio] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });
  const [opEntes, setOpEntes] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });

  const [fechaVen, setFechaVen] = useState({
    opcione1: "",
    opcione2: "",
    opcione3: "",
    opcione4: "",
  });
  const [permisos, setPermisos] = useState({
    acccontribuyente: "0000",
    accactividad: "0000",
    accdeclaraciones: "000",
    accacticontri: "00",
    accagente: "0000",
    accusuariocome: "0000",
  });

  const [url, setUrl] = useState("");

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (props.operacion) {
      setOperacion(props.operacion);
    }

    if (op.reportes != null) {
      setUrl(op.reportes.trim());
    } else {
      setUrl("");
    }
  }, [props.operacion]);

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuariotimbre/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRender();

          setActivate(false);

          var mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
          blanquear();

          if (idusuario === parseInt(props.usuario.idusuario)) {
            localStorage.setItem(
              "acctimbresfis",
              JSON.stringify(itemAcctimbresfis)
            );
            localStorage.setItem(
              "accopexpendios",
              JSON.stringify(itemAccopexpendios)
            );
            localStorage.setItem("accopentes", JSON.stringify(itemAccopentes));
            localStorage.setItem(
              "accconfigtimbres",
              JSON.stringify(itemAccconfigtimbres)
            );
            localStorage.setItem(
              "accpdftimbres",
              JSON.stringify(itemAccpdftimbres)
            );
            localStorage.setItem(
              "accfvmtimbres",
              JSON.stringify(itemAccfvmtimbres)
            );
          }

          console.log(operacion);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              setTabIndex1(0);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeTodo = (e) => {
    if (e.target.name === "todoexpendedores") {
      if (chkExTodo.current.checked) {
        chkExCon.current.checked = true;
        chkExInc.current.checked = true;
        chkExMod.current.checked = true;
        chkExEli.current.checked = true;
      } else {
        chkExCon.current.checked = false;
        chkExInc.current.checked = false;
        chkExMod.current.checked = false;
        chkExEli.current.checked = false;
      }
    } else if (e.target.name === "todoentes") {
      if (chkEntTodo.current.checked) {
        chkEntCon.current.checked = true;
        chkEntInc.current.checked = true;
        chkEntMod.current.checked = true;
        chkEntEli.current.checked = true;
      } else {
        chkEntCon.current.checked = false;
        chkEntInc.current.checked = false;
        chkEntMod.current.checked = false;
        chkEntEli.current.checked = false;
      }
    } else if (e.target.name === "todofechaven") {
      if (chkFvTodo.current.checked) {
        chkFvCon.current.checked = true;
        chkFvInc.current.checked = true;
        chkFvMod.current.checked = true;
        chkFvEli.current.checked = true;
      } else {
        chkFvCon.current.checked = false;
        chkFvInc.current.checked = false;
        chkFvMod.current.checked = false;
        chkFvEli.current.checked = false;
      }
    } else if (e.target.name === "todoexonerar") {
      if (chkExonerar.current.checked) {
        chkExonInteres.current.checked = true;
        chkExonMulta.current.checked = true;
        chkExonRecargo.current.checked = true;
      } else {
        chkExonInteres.current.checked = false;
        chkExonMulta.current.checked = false;
        chkExonRecargo.current.checked = false;
      }
    } else if (e.target.name === "todoexonerarente") {
      if (chkExonerarEnte.current.checked) {
        chkExonInteresEnte.current.checked = true;
        chkExonMultaEnte.current.checked = true;
        chkExonRecargoEnte.current.checked = true;
      } else {
        chkExonInteresEnte.current.checked = false;
        chkExonMultaEnte.current.checked = false;
        chkExonRecargoEnte.current.checked = false;
      }
    }
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleCloseCatalogoAge = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoAge = (idAge, nomAge) => {
    setMostrar4(false);
    txtIdAgente.current.value = idAge;
    txtNombreAgente.current.value = nomAge;
    txtCedula.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoAge = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const blanquear = () => {
    setPassword("");
    setActivate(false);
    setCorreo("");
    setOperacionPer(0);
    setModulos({
      modulo1: "",
      modulo2: "",
      modulo3: "",
      modulo4: "",
      modulo5: "",
      modulo6: "",
      modulo7: "",
      modulo8: "",
    });
    setReportes({
      pdf1: "",
      pdf2: "",
      pdf3: "",
      pdf4: "",
      pdf5: "",
      pdf6: "",
      pdf7: "",
      pdf8: "",
      pdf9: "",
    });
    setOpExpendio({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });
    setOpExonerar({
      opcione1: "",
      opcione2: "",
      opcione3: "",
    });
    setOpExonerarEnte({
      opcione1: "",
      opcione2: "",
      opcione3: "",
    });
    setOpEntes({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });
    setVisibleCheck({
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
    });
    setPermisos({
      acccontribuyente: "0000",
      accactividad: "0000",
      accdeclaraciones: "000",
      accacticontri: "00",
      accagente: "0000",
      accusuariocome: "0000",
    });
    setModulosConfig({
      moduloconfig1: "",
      moduloconfig2: "",
      moduloconfig3: "",
    });
    setFechaVen({
      opcione1: "",
      opcione2: "",
      opcione3: "",
      opcione4: "",
    });

    setitemAcctimbresfis("");
    setItemAccopexpendios("");
    setItemAccopentes("");
    setItemAccconfigtimbres("");
    setItemAccpdftimbres("");
    setItemAccfvmtimbres("");
  };

  const onChange = (e) => {
    if (e.target.id === "modulo") {
      setModulos({ ...modulos, [e.target.name]: e.target.value });

      if (e.target.name === "modulo1") {
        if (e.target.value === "1") {
          setVisibleCheck({ ...visibleCheck, checked1: true });
        } else {
          setVisibleCheck({ ...visibleCheck, checked1: false });
          chkExCon.current.checked = false;
          chkExInc.current.checked = false;
          chkExMod.current.checked = false;
          chkExEli.current.checked = false;
        }
      } else if (e.target.name === "modulo2") {
        if (e.target.value === "1") {
          setVisibleCheck({ ...visibleCheck, checked2: true });
        } else {
          setVisibleCheck({ ...visibleCheck, checked2: false });
          chkEntCon.current.checked = false;
          chkEntInc.current.checked = false;
          chkEntMod.current.checked = false;
          chkEntEli.current.checked = false;
        }
      }
    } else if (e.target.id === "modulosConfig") {
      setModulosConfig({ ...modulosConfig, [e.target.name]: e.target.value });
    } else if (e.target.id === "reportes") {
      setReportes({ ...reportes, [e.target.name]: e.target.value });
    }
  };

  const cancelar = () => {
    blanquear();

    props.onHideCancela();
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const checkExonerar = (e) => {
    if (
      chkExonInteres.current.checked === true &&
      chkExonMulta.current.checked === true &&
      chkExonRecargo.current.checked === true
    ) {
      chkExonerar.current.checked = true;
    } else {
      chkExonerar.current.checked = false;
    }
  };

  const checkExonerarEnte = (e) => {
    if (
      chkExonInteresEnte.current.checked === true &&
      chkExonMultaEnte.current.checked === true &&
      chkExonRecargoEnte.current.checked === true
    ) {
      chkExonerarEnte.current.checked = true;
    } else {
      chkExonerarEnte.current.checked = false;
    }
  };

  const check = (e) => {
    if (
      chkExCon.current.checked === true &&
      chkExInc.current.checked === true &&
      chkExMod.current.checked === true &&
      chkExEli.current.checked === true
    ) {
      chkExTodo.current.checked = true;
    } else {
      chkExTodo.current.checked = false;
    }
  };

  const check2 = (e) => {
    if (
      chkEntCon.current.checked === true &&
      chkEntInc.current.checked === true &&
      chkEntMod.current.checked === true &&
      chkEntEli.current.checked === true
    ) {
      chkEntTodo.current.checked = true;
    } else {
      chkEntTodo.current.checked = false;
    }
  };
  const check3 = (e) => {
    if (
      chkFvCon.current.checked === true &&
      chkFvInc.current.checked === true &&
      chkFvMod.current.checked === true &&
      chkFvEli.current.checked === true
    ) {
      chkFvTodo.current.checked = true;
    } else {
      chkFvTodo.current.checked = false;
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    let expendio = "";
    let entes = "";
    let fecha = "";
    if (modulos.modulo1 === "1") {
      let expendio1 = chkExCon.current.checked ? "1" : "0";
      let expendio2 = chkExInc.current.checked ? "1" : "0";
      let expendio3 = chkExMod.current.checked ? "1" : "0";
      let expendio4 = chkExEli.current.checked ? "1" : "0";

      expendio = expendio1 + expendio2 + expendio3 + expendio4;
    } else {
      expendio = "0000";
    }

    if (modulos.modulo2 === "1") {
      let ente1 = chkEntCon.current.checked ? "1" : "0";
      let ente2 = chkEntInc.current.checked ? "1" : "0";
      let ente3 = chkEntMod.current.checked ? "1" : "0";
      let ente4 = chkEntEli.current.checked ? "1" : "0";

      entes = ente1 + ente2 + ente3 + ente4;
    } else {
      entes = "0000";
    }

    if (modulosConfig.moduloconfig3 === "1") {
      let fecha1 = chkFvCon.current.checked ? "1" : "0";
      let fecha2 = chkFvInc.current.checked ? "1" : "0";
      let fecha3 = chkFvMod.current.checked ? "1" : "0";
      let fecha4 = chkFvEli.current.checked ? "1" : "0";

      fecha = fecha1 + fecha2 + fecha3 + fecha4;
    } else {
      fecha = "0000";
    }

    var sigue = true;
    var mensaje = "";
    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    } else if (
      modulos.modulo1 === "1" &&
      chkExCon.current.checked === false &&
      chkExInc.current.checked === false &&
      chkExMod.current.checked === false &&
      chkExEli.current.checked === false
    ) {
      mensaje = "Debe Seleccionar las Operaciones para el Modulo Expendedores";
      sigue = false;
      chkExCon.current.focus();
    } else if (
      modulos.modulo2 === "1" &&
      chkEntCon.current.checked === false &&
      chkEntInc.current.checked === false &&
      chkEntMod.current.checked === false &&
      chkEntEli.current.checked === false
    ) {
      mensaje = "Debe Seleccionar las Operaciones para el Modulo Entes";
      sigue = false;
      chkEntCon.current.focus();
    } else if (
      modulosConfig.moduloconfig3 === "1" &&
      chkFvCon.current.checked === false &&
      chkFvInc.current.checked === false &&
      chkFvMod.current.checked === false &&
      chkFvEli.current.checked === false
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones para el Modulo Fecha Vencimiento";
      sigue = false;
      chkFvCon.current.focus();
    }

    setitemAcctimbresfis(
      modulos.modulo1 +
        modulos.modulo2 +
        modulos.modulo3 +
        modulos.modulo4 +
        modulos.modulo5 +
        modulos.modulo6 +
        modulos.modulo7 +
        modulos.modulo8
    );
    setItemAccopexpendios(expendio);
    setItemAccopentes(entes);
    setItemAccconfigtimbres(
      modulosConfig.moduloconfig1 +
        modulosConfig.moduloconfig2 +
        modulosConfig.moduloconfig3
    );
    setItemAccpdftimbres(
      reportes.pdf1 +
        reportes.pdf2 +
        reportes.pdf3 +
        reportes.pdf4 +
        reportes.pdf5 +
        reportes.pdf6 +
        reportes.pdf7 +
        reportes.pdf8 +
        reportes.pdf9
    );
    setItemAccfvmtimbres(fecha);

    const exinteres = chkExonInteres.current.checked ? "1" : "0";
    const exmulta = chkExonMulta.current.checked ? "1" : "0";
    const exrecargo = chkExonRecargo.current.checked ? "1" : "0";

    let accexonexpendedor = exinteres + exmulta + exrecargo;

    const exinteresEnte = chkExonInteresEnte.current.checked ? "1" : "0";
    const exmultaEnte = chkExonMultaEnte.current.checked ? "1" : "0";
    const exrecargoEnte = chkExonRecargoEnte.current.checked ? "1" : "0";

    let accexonente = exinteresEnte + exmultaEnte + exrecargoEnte;

    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        idagente: txtIdAgente.current.value,
        acctimbresfis:
          modulos.modulo1 +
          modulos.modulo2 +
          modulos.modulo3 +
          modulos.modulo4 +
          modulos.modulo5 +
          modulos.modulo6 +
          modulos.modulo7 +
          modulos.modulo8,
        accopexpendios: expendio,
        accopentes: entes,
        accconfigtimbres:
          modulosConfig.moduloconfig1 +
          modulosConfig.moduloconfig2 +
          modulosConfig.moduloconfig3,
        accpdftimbres:
          reportes.pdf1 +
          reportes.pdf2 +
          reportes.pdf3 +
          reportes.pdf4 +
          reportes.pdf5 +
          reportes.pdf6 +
          reportes.pdf7 +
          reportes.pdf8 +
          reportes.pdf9,
        accfvmtimbres: fecha,
        accexonexpendedor: accexonexpendedor,
        accexonente: accexonente,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });
      setUsuario(user);
      setPersona(datoPer);
      setContar2(0);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);

        if (props.operacion !== 1) {
          setModulos({
            modulo1:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(0, 1),
            modulo2:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(1, 2),
            modulo3:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(2, 3),
            modulo4:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(3, 4),
            modulo5:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(4, 5),
            modulo6:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(5, 6),
            modulo7:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(6, 7),
            modulo8:
              props.usuario &&
              props.usuario.acctimbresfis.toString().substring(7, 8),
          });
          setReportes({
            pdf1:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(0, 1),
            pdf2:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(1, 2),
            pdf3:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(2, 3),
            pdf4:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(3, 4),
            pdf5:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(4, 5),
            pdf6:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(5, 6),
            pdf7:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(6, 7),
            pdf8:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(7, 8),
            pdf9:
              props.usuario &&
              props.usuario.accpdftimbres.toString().substring(8, 9),
          });
          setOpExpendio({
            opcione1:
              props.usuario &&
              props.usuario.accopexpendios.toString().substring(0, 1),
            opcione2:
              props.usuario &&
              props.usuario.accopexpendios.toString().substring(1, 2),
            opcione3:
              props.usuario &&
              props.usuario.accopexpendios.toString().substring(2, 3),
            opcione4:
              props.usuario &&
              props.usuario.accopexpendios.toString().substring(3, 4),
          });

          setOpExonerar({
            opcione1: props.usuario.accexonexpendedor
              .toString()
              .substring(0, 1),
            opcione2: props.usuario.accexonexpendedor
              .toString()
              .substring(1, 2),
            opcione3: props.usuario.accexonexpendedor
              .toString()
              .substring(2, 3),
          });

          setOpExonerarEnte({
            opcione1: props.usuario.accexonente.toString().substring(0, 1),
            opcione2: props.usuario.accexonente.toString().substring(1, 2),
            opcione3: props.usuario.accexonente.toString().substring(2, 3),
          });

          chkExonInteres.current.checked =
            props.usuario.accexonexpendedor.toString().substring(0, 1) === "1"
              ? true
              : false;
          chkExonMulta.current.checked =
            props.usuario.accexonexpendedor.toString().substring(1, 2) === "1"
              ? true
              : false;
          chkExonRecargo.current.checked =
            props.usuario.accexonexpendedor.toString().substring(2, 3) === "1"
              ? true
              : false;

          if (
            props.usuario.accexonexpendedor.toString().substring(0, 1) ===
              "1" &&
            props.usuario.accexonexpendedor.toString().substring(1, 2) ===
              "1" &&
            props.usuario.accexonexpendedor.toString().substring(2, 3) === "1"
          ) {
            chkExonerar.current.checked = true;
          } else {
            chkExonerar.current.checked = false;
          }

          chkExonInteresEnte.current.checked =
            props.usuario.accexonente.toString().substring(0, 1) === "1"
              ? true
              : false;
          chkExonMultaEnte.current.checked =
            props.usuario.accexonente.toString().substring(1, 2) === "1"
              ? true
              : false;
          chkExonRecargoEnte.current.checked =
            props.usuario.accexonente.toString().substring(2, 3) === "1"
              ? true
              : false;

          if (
            props.usuario.accexonente.toString().substring(0, 1) === "1" &&
            props.usuario.accexonente.toString().substring(1, 2) === "1" &&
            props.usuario.accexonente.toString().substring(2, 3) === "1"
          ) {
            chkExonerarEnte.current.checked = true;
          } else {
            chkExonerarEnte.current.checked = false;
          }

          setOpEntes({
            opcione1:
              props.usuario &&
              props.usuario.accopentes.toString().substring(0, 1),
            opcione2:
              props.usuario &&
              props.usuario.accopentes.toString().substring(1, 2),
            opcione3:
              props.usuario &&
              props.usuario.accopentes.toString().substring(2, 3),
            opcione4:
              props.usuario &&
              props.usuario.accopentes.toString().substring(3, 4),
          });
          setModulosConfig({
            moduloconfig1:
              props.usuario &&
              props.usuario.accconfigtimbres.toString().substring(0, 1),
            moduloconfig2:
              props.usuario &&
              props.usuario.accconfigtimbres.toString().substring(1, 2),
            moduloconfig3:
              props.usuario &&
              props.usuario.accconfigtimbres.toString().substring(2, 3),
          });
          setFechaVen({
            opcione1:
              props.usuario &&
              props.usuario.accfvmtimbres.toString().substring(0, 1),
            opcione2:
              props.usuario &&
              props.usuario.accfvmtimbres.toString().substring(1, 2),
            opcione3:
              props.usuario &&
              props.usuario.accfvmtimbres.toString().substring(2, 3),
            opcione4:
              props.usuario &&
              props.usuario.accfvmtimbres.toString().substring(3, 4),
          });
        } else {
          setModulosConfig({
            moduloconfig1: "0",
            moduloconfig2: "0",
            moduloconfig3: "0",
          });
          setModulos({
            modulo1: "0",
            modulo2: "0",
            modulo3: "0",
            modulo4: "0",
            modulo5: "0",
            modulo6: "0",
            modulo7: "0",
            modulo8: "0",
          });
          setReportes({
            pdf1: "0",
            pdf2: "0",
            pdf3: "0",
            pdf4: "0",
            pdf5: "0",
            pdf6: "0",
            pdf7: "0",
            pdf8: "0",
            pdf9: "0",
          });
        }
        setTabIndex(0);
        setTabIndex1(0);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
              ? "Modificar Usurario"
              : operacion === 3
              ? "Eliminar Usuario"
              : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CatalogoPersona
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <CatalogoAgente
          titulo={titulo}
          mensaje={msg}
          show={mostrar4}
          onHideCancelaCatAge={handleCloseCatalogoAge}
          onHideAceptaCatAge={handleAceptaCatalogoAge}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="">
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active "
                  style={{ backgroundColor: "#25d366" }}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#tab-1"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos Modulo
                  Timbres
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : ""}
                    >
                      <option value="1">Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">Agente</legend>

                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Código
                        Agente:
                      </label>
                      <input
                        type="text"
                        disabled
                        ref={txtIdAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputIdAgente"
                        defaultValue={
                          props.usuario ? props.usuario.idagente : ""
                        }
                        onKeyUp={validarAgente}
                        onBlur={validarAgente}
                      />
                      <button
                        disabled={deshabilitado}
                        onClick={catalogoAge}
                        className="btn btn-sm  btn-success"
                      >
                        <i
                          disabled={deshabilitado}
                          className="fa fa-search"
                        ></i>{" "}
                      </button>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={true}
                        ref={txtNombreAgente}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario"
                        defaultValue={
                          props.usuario ? props.usuario.nombreagente.trim() : ""
                        }
                      />
                    </div>
                  </fieldset>

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtCedula}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCedula"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.cedula
                              : ""
                          }
                          onKeyUp={validarPersona}
                          onBlur={validarPersona}
                        />
                        <button
                          disabled={deshabilitado}
                          onClick={catalogoPer}
                          className="btn btn-sm  btn-success"
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-search"
                          ></i>{" "}
                        </button>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-3 mx-auto px-2">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                          Nacionalidad:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbNacionalidad}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nacionalidad
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example col-md-"
                        >
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-2 ml-auto px-1">
                        <label
                          className="input-group-text ml-2"
                          id="inputGroup-sizing-sm"
                        >
                          Sexo:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbSexo}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.sexo
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtNombreUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nombres.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          apellidos:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtApellidoUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.apellidos.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Direccion:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtDireccionUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.direccion.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-calendar-alt"></i>
                          Fecha Nacimiento:
                        </label>
                        <input
                          type="date"
                          disabled={!habilitadoNU}
                          ref={txtFechaNac}
                          className="form-control px-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputFechaNac"
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          defaultValue={
                            props.datospersonales
                              ? moment(
                                  props.datospersonales.fnacimiento
                                ).format("YYYY-MM-DD")
                              : ""
                          }
                          onKeyUp={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtTlfUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputTlfUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf1 !== null
                                ? props.datospersonales.tlf1.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-mobile-alt"></i>
                          Celular:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtCelUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCelUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf2 !== null
                                ? props.datospersonales.tlf2.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          {" "}
                          <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtEmailUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputEmailUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.correoe !== null
                                ? props.datospersonales.correoe.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade px-2"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#25d366" }}
                      id="ex-with-icons-tab-1"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-1"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-1"
                      aria-selected="true"
                    >
                      <i className="fas fa-edit mx-1" />
                      Actualizar
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#55acee" }}
                      id="ex-with-icons-tab-2"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-2"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-2"
                      aria-selected="false"
                    >
                      <i className="fas fa-cogs mx-1" />
                      Configuración
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link fw-bold text-light rounded"
                      style={{ backgroundColor: "#F93154" }}
                      id="ex-with-icons-tab-3"
                      data-mdb-toggle="tab"
                      href="#ex-with-icons-tabs-3"
                      role="tab"
                      aria-controls="ex-with-icons-tabs-3"
                      aria-selected="false"
                    >
                      <i className="fas fa-file-pdf mx-1" />
                      Reportes
                    </a>
                  </li>
                </ul>

                <div
                  className="tab-content"
                  id="ex-with-icons-content"
                  style={{ fontFamily: "Times New Roman, Times, serif" }}
                >
                  <div
                    className="tab-pane fade show active"
                    id="ex-with-icons-tabs-1"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-1"
                  >
                    <div className="py-1 row mx-auto">
                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Registro de Expendedores{" "}
                          </legend>
                          <div className="col-md-2 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo1"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo1 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo1"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo1 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                          {modulos.modulo1 === "1" ? (
                            <div className="col-md-8 row mb-3 rounded">
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkExCon}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opExpendio.opcione1 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Consultar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkExInc}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opExpendio.opcione2 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Incluir
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkExMod}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opExpendio.opcione3 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Modificar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkExEli}
                                    onChange={check}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opExpendio.opcione4 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Eliminar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkExTodo}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opExpendio.opcione1 === "1" &&
                                      opExpendio.opcione2 === "1" &&
                                      opExpendio.opcione3 === "1" &&
                                      opExpendio.opcione4 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todoexpendedores"
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                    onChange={onChangeTodo}
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Todo
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </fieldset>
                      </div>

                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Exonerar Expendedor
                          </legend>
                          <div className="col-md-8 row mb-3 rounded">
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonInteres}
                                  onChange={checkExonerar}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerar.opcione1 === "1" ? true : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Intereses
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonMulta}
                                  onChange={checkExonerar}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerar.opcione2 === "1" ? true : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Multas
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonRecargo}
                                  onChange={checkExonerar}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerar.opcione3 === "1" ? true : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Recargos
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonerar}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerar.opcione1 === "1" &&
                                    opExonerar.opcione2 === "1" &&
                                    opExonerar.opcione3 === "1"
                                      ? true
                                      : false
                                  }
                                  name="todoexonerar"
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                  onChange={onChangeTodo}
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Todo
                                </label>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Registro de Entes Receptores{" "}
                          </legend>
                          <div className="col-md-2 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo2"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo2 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo2"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo2 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                          {modulos.modulo2 === "1" ? (
                            <div className="col-md-8 row mb-3 rounded">
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    onChange={check2}
                                    ref={chkEntCon}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opEntes.opcione1 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Consultar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    onChange={check2}
                                    ref={chkEntInc}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opEntes.opcione2 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Incluir
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    onChange={check2}
                                    ref={chkEntMod}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opEntes.opcione3 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Modificar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    onChange={check2}
                                    ref={chkEntEli}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opEntes.opcione4 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Eliminar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkEntTodo}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      opEntes.opcione1 === "1" &&
                                      opEntes.opcione2 === "1" &&
                                      opEntes.opcione3 === "1" &&
                                      opEntes.opcione4 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todoentes"
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                    onChange={onChangeTodo}
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Todo
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </fieldset>
                      </div>

                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Exonerar Ente
                          </legend>
                          <div className="col-md-8 row mb-3 rounded">
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonInteresEnte}
                                  onChange={checkExonerarEnte}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerarEnte.opcione1 === "1"
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Intereses
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonMultaEnte}
                                  onChange={checkExonerarEnte}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerarEnte.opcione2 === "1"
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Multas
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonRecargoEnte}
                                  onChange={checkExonerarEnte}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerarEnte.opcione3 === "1"
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Recargos
                                </label>
                              </div>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value="1"
                                  ref={chkExonerarEnte}
                                  id="flexCheckDefault"
                                  defaultChecked={
                                    opExonerarEnte.opcione1 === "1" &&
                                    opExonerarEnte.opcione2 === "1" &&
                                    opExonerarEnte.opcione3 === "1"
                                      ? true
                                      : false
                                  }
                                  name="todoexonerarente"
                                  disabled={
                                    operacion === 1 || operacion === 2
                                      ? false
                                      : true
                                  }
                                  onChange={onChangeTodo}
                                />
                                <label
                                  className="form-check-label py-1"
                                  for="flexCheckDefault"
                                >
                                  Todo
                                </label>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </div>

                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Generación de Timbres Fiscales
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo3"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo3 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo3"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo3 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Asignación de Timbres Fiscales
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo4"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo4 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo4"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo4 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Desasignación de Timbres Fiscales
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo5"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo5 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo5"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo5 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Anulación de Timbres Fiscales
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo6"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo6 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo6"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo6 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Venta de Timbres Fiscales
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo7"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo7 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo7"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo7 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Generar Deuda
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo8"
                                value={"1"}
                                id="modulo"
                                checked={modulos.modulo8 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="modulo8"
                                value={"0"}
                                id="modulo"
                                checked={modulos.modulo8 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="ex-with-icons-tabs-2"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-2"
                  >
                    <div className="row mx-auto">
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Permisos Usuarios
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig1"
                                value={"1"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig1 === "1"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig1"
                                value={"0"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig1 === "0"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Configuración del Modulo
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig2"
                                value={"1"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig2 === "1"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig2"
                                value={"0"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig2 === "0"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>

                      <div className="col-md-12 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Fecha de Vencimiento
                          </legend>
                          <div className="col-md-2 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig3"
                                value={"1"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig3 === "1"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-2 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="moduloconfig3"
                                value={"0"}
                                id="modulosConfig"
                                checked={
                                  modulosConfig.moduloconfig3 === "0"
                                    ? true
                                    : false
                                }
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                          {modulosConfig.moduloconfig3 === "1" ? (
                            <div className="col-md-8 row mb-3 rounded">
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkFvCon}
                                    onChange={check3}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      fechaVen.opcione1 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Consultar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkFvInc}
                                    onChange={check3}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      fechaVen.opcione2 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Incluir
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkFvMod}
                                    onChange={check3}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      fechaVen.opcione3 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Modificar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkFvEli}
                                    onChange={check3}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      fechaVen.opcione4 === "1" ? true : false
                                    }
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Eliminar
                                  </label>
                                </div>
                              </div>
                              <div className="col d-flex justify-content-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="1"
                                    ref={chkFvTodo}
                                    id="flexCheckDefault"
                                    defaultChecked={
                                      fechaVen.opcione1 === "1" &&
                                      fechaVen.opcione2 === "1" &&
                                      fechaVen.opcione3 === "1" &&
                                      fechaVen.opcione4 === "1"
                                        ? true
                                        : false
                                    }
                                    name="todofechaven"
                                    disabled={
                                      operacion === 1 || operacion === 2
                                        ? false
                                        : true
                                    }
                                    onChange={onChangeTodo}
                                  />
                                  <label
                                    className="form-check-label py-1"
                                    for="flexCheckDefault"
                                  >
                                    Todo
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="ex-with-icons-tabs-3"
                    role="tabpanel"
                    aria-labelledby="ex-with-icons-tab-3"
                  >
                    <div className="row mx-auto">
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Expendedores Registrados
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf1"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf1 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf1"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf1 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Entes Receptores Registrados
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf2"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf2 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf2"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf2 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Impresión de Licencias de Expendedores{" "}
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf3"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf3 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf3"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf3 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Impresión de P/A. de Entes
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf4"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf4 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf4"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf4 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Timbres Asignados/Expendedor
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf5"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf5 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf5"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf5 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Timbres Vendidos/Expendedor
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf6"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf6 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf6"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf6 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Timbres Anulados/Expendedor
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf7"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf7 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf7"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf7 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Timbres Inutilizados por Entes
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf8"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf8 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf8"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf8 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6 row mx-auto mb-1">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                          <legend
                            className="float-none fw-bold w-auto"
                            style={{ fontSize: "15px" }}
                          >
                            Stock de Timbres
                          </legend>
                          <div className="col-md-6 pl-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf9"
                                value={"1"}
                                id="reportes"
                                checked={reportes.pdf9 === "1" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                Disponible
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="pdf9"
                                value={"0"}
                                id="reportes"
                                checked={reportes.pdf9 === "0" ? true : false}
                                disabled={
                                  operacion === 1 || operacion === 2
                                    ? false
                                    : true
                                }
                                onChange={onChange}
                              />
                              <label className="form-check-label py-1">
                                No Disponible
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActUsuarioTimbres;



// WEBPACK FOOTER //
// ./src/components/permisosMdulos/modalUsuariosTImbres.js